var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v341.326H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512V256H0z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 256h512v170.663H0z"
})));

export default SvgPl;